export default __webpack_public_path__ + "static/media/obrazkysbez.a50f3442.png";